import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Determination of single number value R’w",
  description:
    "This principle section shows the measured results and reference sound insulation curve which is shifted vertically in 1-dB (or 0.1-dB) steps with the purpose of obtaining the single-number value of the apparent sound reduction index R'w.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {
            label: "Reference curve shift",
            labelPosition: "left",
          },
          items: [
            { name: "none" },
            { name: "-1 dB" },
            { name: "-2 dB" },
            { name: "-7 dB" },
            { name: "-8 dB" },
            { name: "-7.8 dB" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], [], []],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-none.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-1db.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-2db.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-7db.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-8db.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-6-7_8db.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
